// extracted by mini-css-extract-plugin
export default {"section":"sandbox_section__lLYxE","container":"sandbox_container__f5OSr","h2":"sandbox_h2__ahOxV","endCap":"sandbox_endCap__iVJOG"};